import { __ } from "@wordpress/i18n";
import { useRulesContext } from "../../../../../hook/useRulesContext";

export default function TableHeader() {
    const {
        currentShortcodes,
        selectedItems,
        handleSelectAll,
        sortField,
        setSortField,
        sortDirection,
        setSortDirection,
    } = useRulesContext();

    // Reusable function to handle sorting
    const handleSort = (field) => {
        if (sortField === field) {
            setSortDirection((prev) => (prev === "DESC" ? "ASC" : "DESC"));
        } else {
            setSortField(field);
            setSortDirection("ASC");
        }
    };

    // Show sort direction arrow
    const sortDirectionArrow = (field) => {
        if (sortField === field) {
            return <span>{sortDirection === "DESC" ? "↓" : "↑"}</span>;
        }
    };

    return (
        <thead className="bg-gray-50 border-b border-gray-200">
            <tr>
                <th className="px-4 sm:px-6 py-3 text-left">
                    <input
                        type="checkbox"
                        checked={
                            selectedItems.size === currentShortcodes.length &&
                            currentShortcodes.length > 0
                        }
                        onChange={(e) => handleSelectAll(e.target.checked)}
                        className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                    />
                </th>
                <th
                    className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wide whitespace-nowrap"
                    onClick={() => handleSort("id")}
                >
                    {__("ID", "wpbean-quantity-controls-for-woocommerce")}
                    {sortDirectionArrow("id")}
                </th>
                <th
                    className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wide whitespace-nowrap"
                    onClick={() => handleSort("name")}
                >
                    {__("Name", "wpbean-quantity-controls-for-woocommerce")}
                    {sortDirectionArrow("name")}
                </th>
                <th
                    className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wide whitespace-nowrap"
                    onClick={() => handleSort("priority")}
                >
                    {__("Priority", "wpbean-quantity-controls-for-woocommerce")}
                    {sortDirectionArrow("priority")}
                </th>
                <th className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wide whitespace-nowrap">
                    {__("Apply To", "wpbean-quantity-controls-for-woocommerce")}
                </th>
                <th
                    className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wide whitespace-nowrap"
                    onClick={() => handleSort("min")}
                >
                    {__("Min", "wpbean-quantity-controls-for-woocommerce")}
                    {sortDirectionArrow("min")}
                </th>
                <th
                    className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wide whitespace-nowrap"
                    onClick={() => handleSort("max")}
                >
                    {__("Max", "wpbean-quantity-controls-for-woocommerce")}
                    {sortDirectionArrow("max")}
                </th>
                <th
                    className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wide whitespace-nowrap"
                    onClick={() => handleSort("step")}
                >
                    {__("Step", "wpbean-quantity-controls-for-woocommerce")}
                    {sortDirectionArrow("step")}
                </th>
                <th
                    className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wide whitespace-nowrap"
                    onClick={() => handleSort("default")}
                >
                    {__("Default", "wpbean-quantity-controls-for-woocommerce")}
                    {sortDirectionArrow("default")}
                </th>
                <th
                    className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wide whitespace-nowrap"
                    onClick={() => handleSort("rule_status")}
                >
                    {__("Status", "wpbean-quantity-controls-for-woocommerce")}
                    {sortDirectionArrow("rule_status")}
                </th>
                <th className="px-3 py-3 w-10"></th>
            </tr>
        </thead>
    );
}
